export default {_name:'card.simple.small',module:'Field',view:'Element/Card/Small',options:{sm:2,xs:12},mobileOptions:{ms:2}}